/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.standard.controllers', [
  'acme.common.service.api',
  'acme.common.service.posConfig',
  'acme.common.service.templates.helpers',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.factory.gridState'
])
.value('POS_CREATE_PAGES_FORMS_STANDARD_STRINGS', {
  LOCALE: {
    'E_DATE_UNAVAILABLE': 'The selected event is not available on this date. Please choose a different date.',
    'ADVANCE_PUR_DATE': 'Advance purchase date',
    'CURRENT_DATE': 'Current Date',
    'TILE_COLOR': 'Tile color',
    'TICKET': 'Ticket',
    'CALENDAR': 'Calendar',
    'CLOCK': 'Clock'
  },
  ENUM: {
    'ROLLUP': 'rollup',
    'PRESELL': 'presell',
    'CURRENT': 'current',
    'TICKET': 'ticket',
    'CALENDAR': 'calendar',
    'CLOCK': 'clock',
    'OBJECT': 'object'
  }
})
.controller('PosCreatePagesFormsStandardController', [
  '$scope',
  '$timeout',
  '$filter',
  'POS_CREATE_PAGES_FORMS_STANDARD_STRINGS',
  'ApiService',
  'PosConfigService',
  'TemplatesHelpersService',
  'CalendarService',
  'HelpersService',
  'GridStateFactory',
  function($scope,
           $timeout,
           $filter,
           POS_CREATE_PAGES_FORMS_STANDARD_STRINGS,
           ApiService,
           PosConfigService,
           TemplatesHelpersService,
           CalendarService,
           HelpersService,
           GridStateFactory) {

    $scope.posCreatePagesFormsStandard = {

      queryTimer: false,

      model: {}, // Tile
      list: [], // Events
      ticketTypes: [], // price list

      title: '',
      subTitle: '',
      color: '',
      selected: '',
      ticketType: '',
      presellDate: new Date(),
      eventDateType: {},
      eventDateTypes: [
        {
          type: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.CURRENT,
          label: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.CURRENT_DATE
        },
        {
          type: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.PRESELL,
          label: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.ADVANCE_PUR_DATE
        }
      ],

      selectedIcon: {},
      iconTypes: [
        {
          type: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.TICKET,
          label: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.TICKET
        },
        {
          type: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.CALENDAR,
          label: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.CALENDAR
        },
        {
          type: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.CLOCK,
          label: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.CLOCK
        }
      ],

      colorCodes: {
        textColor: '',
        backgroundColor: ''
      },

      spectrumConfig: {
        titleText: POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.TILE_COLOR
      },
      gridState: new GridStateFactory(),

      pageSize: 20,

      formError: '',
      reduceList: false,
      reduceType: false,
      isLoaded: false,
      searching: false,
      lastSearchQuery: '',
      totalServerItems: 1,
      currentTemplate: false,
      loadTimeout: false,

      init: function() {
        $scope.$on('PosCreatePagesFormsController::Update', this.onPosCreatePagesFormsControllerUpdate);
        $scope.$on('PosCreatePagesFormsController::TemplatesUpdate', this.onPosCreatePagesFormsControllerTemplatesUpdate);

        $scope.$watch('posCreatePagesFormsStandard.selected', this.onSelected);
        $scope.$watch('posCreatePagesFormsStandard.ticketType', this.onTicketTypeChange);

        $scope.$watchCollection('posCreatePagesFormsStandard.colorCodes', this.onColorCodesUpdate);

        $scope.$on('destroy', function() {
          $timeout.cancel($scope.posCreatePagesFormsStandard.queryTimer);
          $timeout.cancel($scope.posCreatePagesFormsStandard.loadTimeout);
        });
      },

      initDateWatchers: function(){

        if (this.presellDateWatcher) {
          this.presellDateWatcher();
        }

        if (this.eventDateWatcher) {
          this.eventDateWatcher();
        }

        this.eventDateWatcher = $scope.$watch('posCreatePagesFormsStandard.eventDateType', this.onEventDateTypeUpdate);
        this.presellDateWatcher = $scope.$watch('posCreatePagesFormsStandard.presellDate', this.onPresellDateUpdate);

      },

      getTemplates: function (searchQuery) {
        this.gridState.updateGridState(null, this.pageSize, 'name', 'asc', '');
        this.gridState.gridState.search = searchQuery || '';
        ApiService.program.list(false, angular.extend({admissionType: 'standard'}, this.gridState.getGridState())).then(this.success.getTemplates, this.error.getTemplates);
        console.log(this.gridState.getGridState());
      },

      getEventTemplate: function(id) {
        ApiService.program.get(id).then(this.success.getEventTemplate, this.error.getEventTemplate);
      },

      findTicketType: function(personTypeId) {
        var i, ii,
            r = false;

        for (i=0,ii=this.ticketTypes.length;i<ii;i++) {
          if (this.ticketTypes[i].personType.id === personTypeId) {
            r = {
              ticketType: this.ticketTypes[i],
              index: i
            };
          }
        }

        return r;

      },

      findIcon: function(type) {

        var i, ii,
            r = {};

        for (i=0,ii=this.iconTypes.length;i<ii;i++) {
          if (this.iconTypes[i].type === type) {
            r = this.iconTypes[i];
            break;
          }
        }

        return r;

      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        this.reduceType = false;
        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      hasSelected: function() {
        return (this.selected && typeof this.selected === POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.OBJECT);
      },

      hasTicketType: function() {
        return (this.ticketType && typeof this.ticketType === POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.OBJECT);
      },

      isEventDateType: function(type) {
        return (this.eventDateType.type === type);
      },

      getTitle: function() {
        var r = 'Enter a title';
        if (this.selected && this.selected.name) {
          r = this.selected.name;
        }
        return r;
      },

      getSubtitle: function() {
        var r = 'Enter a subtitle';
        if (this.ticketType && this.ticketType.personType) {
          if (this.ticketType.personType.id !== POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.ROLLUP) {
            r = this.ticketType.personType.name;
          }else {
            r = '';
          }
        }
        return r;
      },

      process: function(events, count) {
        var r = events,
            currentCount = (this.gridState.gridState.page || 1) * this.gridState.gridState.pageSize;

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this.showMore = {
            showMoreLabel: 'Show '+ this.pageSize +' more of ' + count,
            hasMore: true
          };
        } else {
          this.showMore = {
            showMoreLabel: '',
            hasMore: false
          };
        }

        return r;
      },

      checkEventAvailable: function() {
        var startDate,
          endDate;

        if (this.selected.id && this.eventDateType === this.eventDateTypes[1]) {

          startDate = this.presellDate;
          endDate = new Date(this.presellDate);

          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);

          endDate.setHours(23);
          endDate.setMinutes(59);
          endDate.setSeconds(59);

          ApiService.event.list(angular.extend(
            {
              startTime: CalendarService.toISO8601(startDate),
              endTime: CalendarService.toISO8601(endDate),
              cache: true,
              filter: 'templateId=' + this.selected.id
            },
            HelpersService.getPaginator()
          )).then(this.success.checkEventAvailable, this.error.checkEventAvailable);

        }
      },

      remove: function() {
        $scope.$emit('PosCreatePagesFormsController::RemoveTile', this.model);
      },

      cancel: function() {
        $scope.$emit('PosCreatePagesFormsController::Cancel', this.model);
      },

      setTemplate: function() {

        var foundTicket,
          foundTemplate = TemplatesHelpersService.findTemplate(this.list, this.model.id);

        if (foundTemplate || this.currentTemplate) {
          this.selected = !foundTemplate ? this.currentTemplate : this.list[foundTemplate.index];

          // next tick
          $timeout(function() {
            var self = $scope.posCreatePagesFormsStandard;

            if (self.model.typeId) {
              foundTicket = self.findTicketType(self.model.typeId);
            }

            if (self.model.icon) {
              self.selectedIcon = self.findIcon(self.model.icon);
            }

            if (self.model.name && self.model.name.length) {
              self.title = (self.model.name !== self.selected.name) ? self.model.name : '';
            }

            if (self.model.type === POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.PRESELL) {
              self.presellDate = (self.model.presell && self.model.presell.date) ? PosConfigService.parsePresellDate(self.model.presell.date) : new Date();
              self.eventDateType = self.eventDateTypes[1];
            }else {
              self.presellDate = new Date();
              self.eventDateType = self.eventDateTypes[0];
            }

            if (foundTicket) {
              self.ticketType = self.ticketTypes[foundTicket.index];
              if (self.ticketType.personType.id !== POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.ROLLUP) {
                self.subTitle = self.ticketType.personType.name;
              }else{
                self.subTitle = '';
              }
            }

          }, 0);
        }

      },

      resetSelected: function() {
        var foundTemplate, self = $scope.posCreatePagesFormsStandard;
        $timeout(function() {
          //reset template selected if no template is chosen
          if (!self.hasSelected()) {
            foundTemplate = TemplatesHelpersService.findTemplate(self.list, self.model.id);

            if (foundTemplate || self.currentTemplate) {
              self.selected = !foundTemplate ? self.currentTemplate : self.list[foundTemplate.index];
            }

            self.resetTicketType();
          }
          this.reduceList = false;
        },0);
      },

      resetTicketType: function() {
        var foundTicket, self = $scope.posCreatePagesFormsStandard;
        $timeout(function() {
          // reset ticket type of you've reverted to the original template selection
          if (!self.hasTicketType() && self.hasSelected() && self.selected.id === self.model.id) {
            if (self.model.typeId) {
              foundTicket = self.findTicketType(self.model.typeId);
            }

            if (foundTicket) {
              self.ticketType = self.ticketTypes[foundTicket.index];
              if (self.ticketType.personType.id !== POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.ROLLUP) {
                self.subTitle = self.ticketType.personType.name;
              }else{
                self.subTitle = '';
              }
            }
          }
          this.reduceType = false;
        },0);
      },

      search: function(field) {
        this.searching = true;
        ApiService.program.list(false, angular.extend({admissionType: 'standard'}, this.gridState.getGridState())).then(function(response) {
          $scope.posCreatePagesFormsStandard.success.search(response, field);
        }, this.error.search);
      },

      filterList: function(force, field) {

        var timeoutMS = force ? 0 : 500;

        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.posCreatePagesFormsStandard;

          if (force || (typeof self.selected === 'string') && (self.lastSearchQuery !== self.selected)) {
            if (!force) {
              self.gridState.setPropertyValue('pageSize', self.pageSize);
            } else {
              self.gridState.setPropertyValue('pageSize', (self.gridState.gridState.pageSize + self.pageSize) );
            }
            self.gridState.gridState.search = self.hasSelected() ? '' : self.selected;
            self.lastSearchQuery = self.gridState.gridState.search;
            self.search(field);
          }
        }, timeoutMS);
      },

      showMoreResults: function(item) {
        switch(item.field) {
          case 'pos-create-pages-forms-standard-events-list': this.filterList(true, item.field);
            break;
        }
      },

      filterTicketTypes: function(viewValue, reduce) {
        var r;

        if (viewValue && viewValue.length > 0 && (reduce || this.reduceType)) {
          r = $filter('filter')(this.ticketTypes, function(ticketType) {
            return ticketType.personType.name.toLowerCase().indexOf(viewValue.toLowerCase()) > -1 ? ticketType : null;
          });
        }else{
          r =  this.ticketTypes;
        }

        return r;
      },

      done: function() {
        this.model.name = '';
        if (this.title) {
          this.model.name = this.title;
        } else if (this.selected && this.selected.name) {
          this.model.name = this.selected.name;
        }

        if (this.hasSelected()) {
          this.model.id = this.selected.id;
        }

        this.model.subTitle = '';
        if (this.subTitle) {
          this.model.subTitle = this.subTitle;
        } else if (this.ticketType && this.ticketType.personType) {
          if (this.ticketType.personType.id !== POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.ROLLUP) {
            this.model.subTitle = this.ticketType.personType.name;
          }
        }

        if (this.ticketType && this.ticketType.personType) {
          this.model.typeId = this.ticketType.personType.id;
        }

        if (this.selectedIcon && this.selectedIcon.hasOwnProperty('type')) {
          this.model.icon = this.selectedIcon.type;
        }else{
          this.model.icon = 'none';
        }

        this.model.color = PosConfigService.tiles.toColor(this.color);
        if (!this.model.color.a) {
          this.model.color.a = 1;
        }

        if (this.model.config.pageId) {
          this.model.config.pageId = null;
          delete this.model.config.pageId;
        }

        if (this.eventDateType.type === POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.PRESELL) {
          this.model.presell = {
            date: PosConfigService.dateToPresellDate(this.presellDate)
          };
        }else {
          this.model.presell = null;
          delete this.model.presell;
        }

        this.model.type = PosConfigService.tiles.getType(this.model, 'standard');

        PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), this.model);
        $scope.$emit('PosCreatePagesFormsController::UpdateTile');
      },

      isLoading: function() {
        return $scope.posCreatePagesFormsStandard.searching;
      },

      success: {
        init: function(response) {},

        getTemplates: function(response) {

          var self = $scope.posCreatePagesFormsStandard;

          self.totalServerItems = response.data.payload.pagination.count;

          self.list = self.process(response.data.payload.list, self.totalServerItems);

          self.isLoaded = true;

        },

        getEventTemplate: function(response) {
          var self = $scope.posCreatePagesFormsStandard;

          self.currentTemplate = response.data.payload;

          if (self.currentTemplate.priceLists instanceof Array &&
            self.currentTemplate.priceLists[0] &&
            self.currentTemplate.priceLists[0].prices instanceof Array) {
            self.ticketTypes = PosConfigService.processPricesBySalesChannel(self.currentTemplate.priceLists[0].prices);
          }

          self.setTemplate();

          //only fetch the initial list once.
          self.getTemplates();
        },

        search: function(response, field) {
          var self = $scope.posCreatePagesFormsStandard;

          self.list = self.process(response.data.payload.list, response.data.payload.pagination.count);

          self.searching = false;

          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: field});
          }

        },

        checkEventAvailable: function(response) {
          var self = $scope.posCreatePagesFormsStandard,
            list = response.data.payload.list,
            i, ii, found;

          for (i = 0, ii = list.length; i < ii; i++) {
            if (self.selected.id === list[i].templateId) {
              found = true;
              break;
            }
          }

          if (!found) {
            self.formError = POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.LOCALE.E_DATE_UNAVAILABLE;
          }

        }
      },

      error: {
        init: function(response) {},

        getTemplates: function(response) {
          var self = $scope.posCreatePagesFormsStandard;

          self.totalServerItems = 0;

          self.list = [];

          self.setTemplate();

          self.isLoaded = true;
        },

        getEventTemplate: function(response) {
          var self = $scope.posCreatePagesFormsStandard;
          self.currentTemplate = false;
        },

        search: function(response) {
          var self = $scope.posCreatePagesFormsStandard;

          self.list = [];

          self.searching = false;
        },

        checkEventAvailable: function() {}
      },

      onSelected: function(n, o) {
        var self = $scope.posCreatePagesFormsStandard;
        self.model.hasError = false;

        if (self.hasSelected() && self.model.id === self.selected.id) {
          if (self.model.name && self.model.name.length) {
            self.title = (self.model.name !== self.selected.name) ? self.model.name : '';
          }else{
            self.title = '';
          }
        } else {
          self.title = '';
          self.subTitle = '';
          self.ticketType = '';
        }

        // next tick
        if (self.loadTimeout) {
          $timeout.cancel(self.loadTimeout);
        }
        self.loadTimeout = $timeout(function() {
          if (self.selected.priceLists instanceof Array &&
              self.selected.priceLists[0] &&
              self.selected.priceLists[0].prices instanceof Array) {
            self.ticketTypes = PosConfigService.processPricesBySalesChannel(self.selected.priceLists[0].prices);
          }

          if (self.model.hasOwnProperty(POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.PRESELL)) {
            self.eventDateType = self.eventDateTypes[1];
            self.presellDate = PosConfigService.parsePresellDate(self.model.presell.date);
          }else{
            self.eventDateType = self.eventDateTypes[0];
          }

        }, 200);
      },

      onTicketTypeChange: function() {
        var self = $scope.posCreatePagesFormsStandard;

        if (self.hasTicketType() && self.ticketType.personType) {
          if (self.ticketType.personType.id !== POS_CREATE_PAGES_FORMS_STANDARD_STRINGS.ENUM.ROLLUP) {
            if (self.model.typeId === self.ticketType.personType.id) {
              self.subTitle = self.model.subTitle;
            } else {
              self.subTitle = '';
            }
          }else{
            self.model.typeId = null;
            delete self.model.typeId;

            self.subTitle = '';
          }
        }
      },

      onEventDateTypeUpdate: function(n, o) {
        var self = $scope.posCreatePagesFormsStandard;
        self.formError = "";
        if (n !== o) {
          self.checkEventAvailable();
        }
      },

      onPresellDateUpdate: function(n, o) {
        var self = $scope.posCreatePagesFormsStandard;
        // check if the event is available on this date if presell date
        self.formError = "";
        if (n !== o) {
          self.checkEventAvailable();
        }
      },

      onPosCreatePagesFormsControllerUpdate: function(e, data) {

        var self = $scope.posCreatePagesFormsStandard;
        
        if (data.config.type === 'standard') {

          self.selected = '';
          self.ticketType = '';
          self.formError = '';

          self.model = data;
          // Force watcher change event by resetting color to black
          self.spectrumConfig.color = '#000000';
          self.color = PosConfigService.tiles.toHex(PosConfigService.tiles.colorToRgb(self.model));
          // next tick
          $timeout(function() {
            self.spectrumConfig.color = self.color;
          }, 0);

          if (self.model.id) {
            if (self.currentTemplate.id !== self.model.id) {
              self.getEventTemplate(self.model.id);
            } else {
              self.setTemplate();
            }
          } else {
            self.currentTemplate = false;
            self.getTemplates();
          }

          self.initDateWatchers();
          self.checkEventAvailable();

        }

      },

      onPosCreatePagesFormsControllerTemplatesUpdate: function(e, data) {
        if (data) {
          $scope.posCreatePagesFormsStandard.totalServerItems = data.count || 0;
        }

      },

      onColorCodesUpdate: function(n, o) {
        if (n && n !== o) {
          $scope.posCreatePagesFormsStandard.color = n.backgroundColor;
        }
      }

    };

    $scope.posCreatePagesFormsStandard.init();

}]);